import { TFunction } from "i18next";
import { ProviderContext } from "notistack";
import { FileDropErrorCode, FileRejection } from "../typings/FileObject.type";

export function handleFileRejections({
  fileRejections,
  maxFiles,
  enqueueSnackbar,
  t
}: {
  fileRejections: readonly FileRejection[];
  maxFiles: number;
  enqueueSnackbar: ProviderContext["enqueueSnackbar"];
  t: TFunction;
}) {
  if (!fileRejections.length) return;

  const errTooLarge = fileRejections.some(({ errors }) =>
    errors.some(err => err.code === FileDropErrorCode.FileTooLarge)
  );
  const errTooMany = fileRejections.some(({ errors }) =>
    errors.some(err => err.code === FileDropErrorCode.TooManyFiles)
  );
  if (errTooLarge) {
    enqueueSnackbar(t("The file can not be bigger than 5MB"), { variant: "error" });
  } else if (errTooMany) {
    enqueueSnackbar(t("You can upload a maximum of no files", { no: maxFiles }), {
      variant: "error"
    });
  } else {
    enqueueSnackbar(t("This is not a valid file"), { variant: "error" });
  }
}
